import React from 'react';
import classnames from 'classnames';

import * as S from './Card.module.css';
import * as T from './Card.types';

export const CardList: React.FunctionComponent<T.ICardListProps> = ({
  children,
  className,
}) => <div className={classnames(S.cardList, className)}>{children}</div>;
